import { EditorOptions, useEditor } from '@tiptap/vue-3';
import { ref } from 'vue';
import { computed, watch } from 'vue';
import { getExtensions, getTipTapText } from '@opinionx/tiptap-extensions';

export const useTipTapEditor = (
  content: string,
  options: Parameters<typeof getExtensions>[0],
  editorOptions?: Partial<EditorOptions>,
) => {
  const editor = useEditor({
    content: content,
    extensions: getExtensions(options),
    ...editorOptions,
  });
  const contentRef = ref(content);
  watch(
    () => contentRef.value,
    (value) => {
      if (editor.value?.getHTML() === value) {
        return;
      }
      editor.value?.commands.setContent(value ?? '', false);
    },
  );
  const unwrappedEditor = computed(() => editor.value);
  return { editor: unwrappedEditor, content: contentRef };
};

export const useTipTapText = getTipTapText;
